module.exports = __webpack_public_path__ + "img/Natural_material_1200x800.8a7766a9.png";